<template>
  <Toast />
  <div class="p-grid">
    <div class="p-col-12">
      <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
        <h5>Admin Permissions</h5>
        <div>
          <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
          <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious" icon="pi pi-chevron-left" />
          <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm" iconPos="right" />
        </div>
      </div>
      <div class="card">
        <div>
          <span class="subtext p-mt-2 p-text-capitalize">
            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : "-" }}</h6>
          </span>
        </div>
        <div style="position: relative" v-if="!showloaderpage" @keydown.enter="onSubmit">
          <div class="p-py-4 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12">
                <Tree :value="nodes" selectionMode="checkbox" v-model:selectionKeys="selectedTreeValue"
                  :expandedKeys="expandedKeys" class="custom-users-role">
                </Tree>
              </div>
            </div>
          </div>
          <div class="p-d-flex p-pt-4">
            <Button v-if="!showLoader" label="Submit" icon="pi pi-check" class="p-button-text p-ml-auto"
              @click="updateAdminMenuPermissions" style="width: 90px"></Button>
            <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
              style="width: 90px"></Button>
          </div>
        </div>
        <div v-if="showloaderpage" style="height: 390px; position: relative">
          <div class="custom-modal-spinner-loader">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../service/ApiService";
import { useRoute } from "vue-router";
import useValidate from "@vuelidate/core";
import router from "@/router";
import { helpers, requiredIf } from "@vuelidate/validators";

export default {
  data() {
    return {
      v$: useValidate(),
      showLoader: false,
      loading: false,
      page_no: 0,
      totalRecords: 0,
      localAdminName: "",
      adminUsersList: [],
      admin_user_fks: [],
      routeParam: 0,
      disabledFlag: false,
      serverStatus: [],
      adminPermissionsList: [],
      selectedPermissions: [],
      nodes: [],
      selectedTreeValue: [],
      showloaderpage: false,
      expandedKeys: [],
    };
  },

  ApiService: null,
  interval: null,
  validations() {
    return {
      selectedTreeValue: {
        requiredIf: helpers.withMessage(
          "Please select module",
          requiredIf(this.roletype == 2)
        ),
      },
    };
  },
  created() {
    this.ApiService = new ApiService();
  },
  mounted() {
    this.loading = true;
    const route = useRoute();
    this.routeParam = route.params.adminSubId;
    this.localAdminName = localStorage.localAdminName;
    this.getAllAdminMenus();
    this.getAdminUserDetails({ maa1: this.routeParam });
  },
  methods: {
    getAllAdminMenus() {
      this.loading = true;
      this.ApiService.getAllAdminMenus({ maa1: this.routeParam }).then((data) => {
        if (data.status == 200) {
          this.nodes = data.data;
        } else {
          this.nodes = "";
        }
        this.loading = false;
      });
    },

    getAdminUserDetails(item) {
      this.showloaderpage = true;
      this.ApiService.getAdminUserDetails(item).then((data) => {
        if (data.status == 200) {
          this.clientConfig = data.data.records;
          this.selectedTreeValue = [];
          if (this.clientConfig.maa83 != null) {
            let arrConverted = this.clientConfig.maa83.split(",");
            // this.selectedTreeValue = arrConverted;
            this.selectedTreeValue = {};
            for (let index = 0; index < arrConverted.length; index++) {
              let idxx = parseInt(arrConverted[index]); // Ensure the key is treated as an integer
              this.selectedTreeValue[idxx] = { checked: true, partialChecked: false };
            }
          }
          this.showloaderpage = false;
          this.submitted = false;
        }
        this.showloaderpage = false;
      });
    },

    updateAdminMenuPermissions() {
      var result = Object.keys(this.selectedTreeValue).map((key) => [
        this.selectedTreeValue[key],
      ]);
      var module_key = [];
      for (let a = 0; a < result.length; a++) {
        for (let i = 0; i < result[a].length; i++) {
          if (result[a][i]["key"] != undefined) {
            module_key.push(result[a][i]["key"]);
          }
        }
      }
      this.submitted = true;
      this.v$.$validate();
      var formData = new FormData();
      formData.append("maa1", this.routeParam);
      formData.append("modules", JSON.stringify(this.selectedTreeValue));

      // for (var pair of formData.entries()) {
      //     console.log(pair[0] + ' - ' + pair[1]);
      // }

      if (!this.v$.$error) {
        this.showLoader = true;
        this.ApiService.updateAdminMenuPermissions(formData).then((items) => {
          if (items.status == 200) {
            this.showLoader = false;
            var successMsg = items.message;
            this.addUserDialogStatus = false;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: successMsg,
              life: 3000,
            });
            setTimeout(() => {
              this.goToDashboard();
            }, 3000);
          } else {
            this.showLoader = false;
            var errorMsg = items.message;
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: errorMsg,
              life: 3000,
            });
          }
        });
      }
    },

    goToDashboard() {
      router.push({
        name: "admindashboard",
        params: { adminId: this.routeParam },
      });
    },

    goToPrevious() {
      router.push({
        name: "adminrole",
        params: { adminSubId: this.routeParam },
      });
    },

    goToNext() {
      router.push({
        name: "adminaddfund",
        params: { adminSubId: this.routeParam },
      });
    },
  },
};
</script>

<style scoped></style>
